<template>
  <b-col class="page-column" :class="{ 'page-column--narrow': columnFitState.narrow }" :style="columnStyle">
    <template v-for="(comp, index) in this.internalFormComponents" :key="comp.uniqueTitle">
      <component
        :is="comp"
        v-if="comp"
        v-bind:items="comp.items"
        v-bind:uniqueTitle="comp.uniqueTitle"
        v-bind:formComponents="comp.formComponents"
        v-bind:columnFormat="comp.columnFormat"
        v-bind:richTextContent="comp.richTextContentValue"
        v-bind:menuItems="comp.menuItemsValue"
        v-bind:title="comp.titleValue"
        v-bind:staticImageId="comp.staticImageIdValue"
        v-bind:altText="comp.altTextValue"
        v-bind:submissionRules="comp.submissionRules"
        v-bind:twoFactor="comp.twoFactorValue"
        v-bind:defaultValueRules="comp.defaultValueRules"
        v-bind:formActions="comp.formActions"
      />
    </template>
  </b-col>
</template>

<script>

import { markRaw } from 'vue'
import _ from 'lodash'
import axios from 'axios'
import Table from './table.vue'
import Carousel from './carousel.vue'
import Cards from './cards.vue'
import Maps from './maps.vue'
import Calendar from './calendar.vue'
import Form from './form.vue'
import LoginForm from './loginform.vue'
import RegisterForm from './registerform.vue'
import Chart from './chart.vue'
import Pivot from './pivot.vue'
import CustomView from './custom.vue'
import RichTextView from './richtext.vue'
import StaticImageView from './staticimage.vue'
import PageMenu from './pagemenu.vue'
import { shouldRenderView } from '../lib/view-visibility'
import { buildViewFieldModel } from '../../../shared/view-fields'
import { normalizeTableLayout } from '../../../shared/table-layout'
import { MAP_ROW_LIMIT, stampMapPoint } from '../../../shared/map-location'
import { CALENDAR_ROW_LIMIT, stampCalendarEvent } from '../../../shared/calendar-event'
import { formatAppInstant } from '../lib/app-time-zone'
import { imageCellHtml, imageDataUrl, imageFilename, imageMarkupSource } from '../../../shared/image-column'
import { displayListValue, listDisplayMap } from '../../../shared/multiselect-display'
import { cardUsesOnePerRow, cardsAcross } from '../../../shared/card-layout'
import { assignColumnFormat, columnFormatStyle } from '../../../shared/column-format'
import { columnFitMixin } from '../lib/column-fit'
import { copySubmissionConfig } from '../../../shared/submission-redirect'
import { assignPresetFilterProps } from '../lib/preset-filter-state'

// Lazy-load Row and Column to avoid circular dependencies
const getComponentMap = () => ({
  table: Table,
  pivot: Pivot,
  custom: CustomView,
  cards: Cards,
  card: Cards,
  maps: Maps,
  calendar: Calendar,
  form: Form,
  login: LoginForm,
  registration: RegisterForm,
  row: require('./row2.vue').default,
  column: require('./column.vue').default,
  carousel: Carousel,
  chart: Chart,
  richtext: RichTextView,
  staticimage: StaticImageView,
  menu: PageMenu
})

const getData = async (componentUniqueTitle) => {

}

export default {
  mixins: [columnFitMixin],
  props: ['formComponents', 'uniqueTitle', 'columnFormat'],
  data() {
    return {
      internalFormComponents: []
    }
  },
  watch: {
    formComponents: {
      immediate: true,
      async handler () {

        console.log(`column formComponents handler called!`)
        console.log(this)
        console.log(this.uniqueTitle)
        console.log(this.formComponents)

        this.internalFormComponents = []
        let counter = 0
        let noUniqueTitleCounter = 0

        if (!this.formComponents) {

          return
        }

        const componentMap = getComponentMap()

        for (let component of this.formComponents) {

          if (!shouldRenderView(component)) continue

          console.log(`col1 adding component ${component.type} with placeholder ${component.placeholder} >`)
          console.log(component)

          let instantiatedComponent = _.cloneDeep(componentMap[component.type])

          console.log(`ABOUT TO TRIGGER UPDATE WITH ${component.uniqueTitle} on`)
          console.log(instantiatedComponent)

          if (!component.uniqueTitle) {

            component.uniqueTitle = `component_without_unique_title_${noUniqueTitleCounter++}`
          }

          // Vue 3: direct assignment instead of this.$set
          instantiatedComponent.uniqueTitle = component.uniqueTitle

          if (component.type === `form` || component.type === `login` || component.type === `registration` || component.type === `row` || component.type === `column`) {

            instantiatedComponent.formComponents = component.components
          }

          assignColumnFormat(instantiatedComponent, component)

          instantiatedComponent.title = component.title
          instantiatedComponent.titleValue = component.title || ''

          copySubmissionConfig(instantiatedComponent, component)

          if (!instantiatedComponent.props.userFiltering) {

            instantiatedComponent.props.userFiltering = {}
          }

          instantiatedComponent.props.userFiltering.default = component.userFiltering

          if (!instantiatedComponent.props.csvExport) {

            instantiatedComponent.props.csvExport = {}
          }

          instantiatedComponent.props.csvExport.default = !!component.csvExport

          if (!instantiatedComponent.props.tableLayout) {

            instantiatedComponent.props.tableLayout = {}
          }

          instantiatedComponent.props.tableLayout.default = component

          if (!instantiatedComponent.props.searchEnabled) {

            instantiatedComponent.props.searchEnabled = {}
          }

          instantiatedComponent.props.searchEnabled.default = component.searchEnabled === true || component.searchEnabled === 'true'

          if (component.type === `cards` || component.type === `card`) {

            if (!instantiatedComponent.props.oneCardPerRow) {

              instantiatedComponent.props.oneCardPerRow = {}
            }

            instantiatedComponent.props.oneCardPerRow.default = component.type === `card` || cardUsesOnePerRow(component)

            if (!instantiatedComponent.props.cardsPerRow) {

              instantiatedComponent.props.cardsPerRow = {}
            }

            instantiatedComponent.props.cardsPerRow.default = cardsAcross(component) || 0
          }

          if (component.type === `card`) {

            if (!instantiatedComponent.props.detail) instantiatedComponent.props.detail = {}
            instantiatedComponent.props.detail.default = true
            instantiatedComponent.props.searchEnabled.default = false
            if (!instantiatedComponent.props.userFiltering) instantiatedComponent.props.userFiltering = {}
            instantiatedComponent.props.userFiltering.default = false
          }

          if (!instantiatedComponent.props.addressColumn) instantiatedComponent.props.addressColumn = {}
          instantiatedComponent.props.addressColumn.default = component.addressColumn || ''
          if (!instantiatedComponent.props.latitudeColumn) instantiatedComponent.props.latitudeColumn = {}
          instantiatedComponent.props.latitudeColumn.default = component.latitudeColumn || ''
          if (!instantiatedComponent.props.longitudeColumn) instantiatedComponent.props.longitudeColumn = {}
          instantiatedComponent.props.longitudeColumn.default = component.longitudeColumn || ''
          if (!instantiatedComponent.props.mapStyleUrl) instantiatedComponent.props.mapStyleUrl = {}
          instantiatedComponent.props.mapStyleUrl.default = component.mapStyleUrl || ''
          if (!instantiatedComponent.props.dateColumn) instantiatedComponent.props.dateColumn = {}
          instantiatedComponent.props.dateColumn.default = component.dateColumn || ''
          if (!instantiatedComponent.props.titleColumn) instantiatedComponent.props.titleColumn = {}
          instantiatedComponent.props.titleColumn.default = component.titleColumn || ''
          if (!instantiatedComponent.props.descriptionColumn) instantiatedComponent.props.descriptionColumn = {}
          instantiatedComponent.props.descriptionColumn.default = component.descriptionColumn || ''
          if (!instantiatedComponent.props.recurrenceColumn) instantiatedComponent.props.recurrenceColumn = {}
          instantiatedComponent.props.recurrenceColumn.default = component.recurrenceColumn || ''
          if (!instantiatedComponent.props.calendarLayout) instantiatedComponent.props.calendarLayout = {}
          instantiatedComponent.props.calendarLayout.default = component.calendarLayout || 'month'
          if (!instantiatedComponent.props.addFormUniqueTitle) instantiatedComponent.props.addFormUniqueTitle = {}
          instantiatedComponent.props.addFormUniqueTitle.default = component.addFormUniqueTitle || ''

          if (!instantiatedComponent.props.filters) {

            instantiatedComponent.props.filters = {}
          }

          instantiatedComponent.props.filters.default = component.filters

          if (component.type === `table` || component.type === `cards` || component.type === `card` || component.type === `maps` || component.type === `calendar`) {

            console.log(`build evengt`)
            console.log(`filter-changed-${component.uniqueTitle}`)

            // Vue 3: this.$on is removed, store callback directly
            // (filter events handled via $parent.filterUpdate pattern)

            console.log('YES YES YES ' + component.type)

            const fieldModel = buildViewFieldModel(component)
            const fieldCounterMap = fieldModel.fieldCounterMap

            if (!instantiatedComponent.props.fields) {

              instantiatedComponent.props.fields = {
                default: []
              }
            }

            instantiatedComponent.props.fields.default = fieldModel.fields

            if (fieldModel.layout) {

              if (!instantiatedComponent.props.layout) {

                instantiatedComponent.props.layout = { default: null }
              }

              instantiatedComponent.props.layout.default = fieldModel.layout
            }

            console.log(this)
            console.log(`the field counter map!!!`)
            console.log(fieldCounterMap)

            if (component.type === `card`) {

              instantiatedComponent.items = await this.getDetailCard(component.uniqueTitle, fieldCounterMap, component)
            } else {

              instantiatedComponent.items = await this.getDataTable(component.uniqueTitle, fieldCounterMap, component)
            }

            // [{ id: 1, test: 'asdf', links: { xyzxxxz: 'asdf' } },
            // { id: 2, test: 'asdf', links: { xyzxxxz: 'asdf' } }] //await this.getData(component.uniqueTitle)
          }

          if (component.type === `pivot`) {

            const assignDefault = (name, value) => {

              if (!instantiatedComponent.props[name]) instantiatedComponent.props[name] = {}

              instantiatedComponent.props[name].default = value
            }

            assignDefault('realtime', !!component.realtime)
            assignDefault('restrictUserFiltering', !!component.restrictUserFiltering)
            assignDefault('defaultUserFilters', component.defaultUserFilters || [])
            assignDefault('defaultUserFilterMatchMode', component.defaultUserFilterMatchMode || 'all')
            assignDefault('spreadSheetUniqueTitle', component.spreadSheet || '')
            assignDefault('pageUniqueTitle', this.routePageUniqueTitle || window.__superturbo_getPageUniqueTitle?.() || '')
            assignDefault('componentUniqueTitle', component.uniqueTitle)
            assignDefault('pivotConfig', {
              rowFields: component.rowFields || [],
              columnFields: component.columnFields || [],
              valueFields: component.valueFields || [],
              showSubtotals: component.showSubtotals,
              showRowGrandTotal: component.showRowGrandTotal,
              showColumnGrandTotal: component.showColumnGrandTotal
            })
          }

          if (component.type === `custom`) {

            const assignDefault = (name, value) => {

              if (!instantiatedComponent.props[name]) instantiatedComponent.props[name] = {}

              instantiatedComponent.props[name].default = value
            }

            assignDefault('viewCode', component.viewCode || '')
            assignDefault('viewCss', component.viewCss || '')
            assignDefault('realtime', !!component.realtime)
            assignDefault('restrictUserFiltering', !!component.restrictUserFiltering)
            assignDefault('defaultUserFilters', component.defaultUserFilters || [])
            assignDefault('defaultUserFilterMatchMode', component.defaultUserFilterMatchMode || 'all')
            assignDefault('spreadSheetUniqueTitle', component.spreadSheet || '')
            assignDefault('pageUniqueTitle', this.routePageUniqueTitle || window.__superturbo_getPageUniqueTitle?.() || '')
            assignDefault('componentUniqueTitle', component.uniqueTitle)
          }

          if (component.type === `carousel`) {

            instantiatedComponent.items = await this.getDataCarousel(component.uniqueTitle)
          }

          if (component.type === `richtext`) {

            instantiatedComponent.richTextContentValue = component.richTextContent || ''
          }

          if (component.type === `staticimage`) {

            instantiatedComponent.staticImageIdValue = component.staticImageId || null
            instantiatedComponent.altTextValue = component.altText || ''
            instantiatedComponent.titleValue = component.title || ''
          }

          if (component.type === `menu`) {

            instantiatedComponent.menuItemsValue = _.cloneDeep(component.menuItems || [])
            instantiatedComponent.titleValue = component.title || ''
          }

          //instantiatedComponent.items = await intake.getData(appSchema.pages[0].uniqueTitle, component.uniqueTitle, this.linkParent)

          console.log(`push ${component.uniqueTitle} / ${instantiatedComponent.uniqueTitle}`)
          console.log(instantiatedComponent)
          console.log(`fiuelkds`)
          //console.log(instantiatedComponent.props.fields.default)
          console.log(instantiatedComponent.items)

          assignPresetFilterProps(instantiatedComponent, component)

          this.internalFormComponents.push(markRaw(instantiatedComponent))

          continue
        }
      }
    }
  },
  computed: {
    columnStyle () {

      return columnFormatStyle(this.columnFormat) || { minWidth: '250px' }
    }
  },
  methods: {
    onSubmit (event) {

      return event.preventDefault()
    },
    async getDataTable (componentUniqueTitle, fieldCounterMap, locationView) {

      const tableLayout = locationView && locationView.type === 'table' ? normalizeTableLayout(locationView) : null
      const rowLimit = locationView && locationView.type === 'maps'
        ? MAP_ROW_LIMIT
        : (locationView && locationView.type === 'calendar'
          ? CALENDAR_ROW_LIMIT
          : (tableLayout && tableLayout.pageSize ? tableLayout.pageSize : 25))
      let url = `${VUE_APP_PROXY_SERVER_URL}/${this.routeAccount}/${this.$route.params.application}/pages/${this.routePageUniqueTitle || window.__superturbo_getPageUniqueTitle()}/components/${componentUniqueTitle}?limit=${rowLimit}`

      const accessKey = this.routeAccessKey
      if (accessKey) {
        url += `&accessKey=${encodeURIComponent(accessKey)}`
      }

      let componentData = await axios.get(url)

      return this.formatViewRows(componentData.data, fieldCounterMap, locationView)
    },
    formatViewRows (rows, fieldCounterMap, locationView) {

      const displays = listDisplayMap(locationView)

      return _.map(rows || [], (row) => {

        let newRow = {}
        let rawRow = {}

        newRow._values = row
        if (row.id !== undefined) newRow._rowId = row.id
        if (row._id !== undefined) newRow._rowId = row._id
        if (row._formatting) newRow._formatting = row._formatting

        for (const key of Object.keys(row)) {

          if (key === '_formatting' || key === '_links' || key === 'links') continue
          if (key.endsWith(`_filename`) || key.endsWith(`_type`)) continue

          let column = row[key]

          if (typeof fieldCounterMap[key] !== `number`) continue

          rawRow[fieldCounterMap[key]] = column

          const imageHtml = imageCellHtml(row, key)

          if (imageHtml != null) {

            column = imageHtml
          } else {

            const listed = displayListValue(column, displays[key])

            if (listed != null) column = listed
            else if (typeof column === 'string') column = formatAppInstant(column)
          }

          newRow[fieldCounterMap[key]] = column
        }

        if (row._links) newRow._links = row._links
        if (row.links) newRow.links = row.links

        newRow._raw = rawRow
        stampMapPoint(newRow, row, locationView)
        stampCalendarEvent(newRow, row, locationView)
        return newRow
      })
    },
    async getDetailCard (componentUniqueTitle, fieldCounterMap, locationView) {

      if (window.__superturbo_preview_mode) {

        const row = {}

        for (const [fieldName, fieldIndex] of Object.entries(fieldCounterMap || {})) {

          row[fieldIndex] = `Sample ${String(fieldName).replace(/_/g, ' ')}`
        }

        return [row]
      }

      const accessKey = this.routeAccessKey

      if (!accessKey) return []

      const url = `${VUE_APP_PROXY_SERVER_URL}/${this.routeAccount}/${this.$route.params.application}/pages/${this.routePageUniqueTitle || window.__superturbo_getPageUniqueTitle()}/components/${componentUniqueTitle}/accesskey/${encodeURIComponent(accessKey)}`

      try {

        const response = await axios.get(url)
        const row = response.data

        if (!row || typeof row !== 'object' || Array.isArray(row)) return []

        return this.formatViewRows([row], fieldCounterMap, locationView)
      } catch (err) {

        console.warn('Failed to load the record for this card:', err)
        return []
      }
    },
    async getDataCarousel (componentUniqueTitle) {

      console.log(`GET DATA CAROUSEL`)

      let carouselUrl = `${VUE_APP_PROXY_SERVER_URL}/${this.routeAccount}/${this.$route.params.application}/pages/${this.routePageUniqueTitle || window.__superturbo_getPageUniqueTitle()}/components/${componentUniqueTitle}?limit=25`

      const carouselAccessKey = this.routeAccessKey
      if (carouselAccessKey) {
        carouselUrl += `&accessKey=${encodeURIComponent(carouselAccessKey)}`
      }

      let componentData = await axios.get(carouselUrl)

      console.log('axios res')
      console.log(componentData.data)

      componentData.data = _.map(componentData.data, (row) => {

        console.log(`Cformat r0w`)
        console.log(row)

        let newRow = {}

        for (const key of Object.keys(row)) {

          if (key.endsWith(`_filename`) || key.endsWith(`_type`)) {

            continue
          }

          let column = row[key]

          console.log(`format col`)
          console.log(column)

          const imageSource = imageDataUrl(row, key) || imageMarkupSource(column)

          if (imageSource) {

            const filename = imageFilename(row, key) || row[`${key}_filename`] || ''

            return {
              caption: filename,
              text: filename,
              imageSource
            }
          }

          newRow[key] = column
        }

        return newRow
      })

      console.log(`Cdata2`)
      console.log(componentData.data)

      return componentData.data
    }
  }
}
</script>
